export default __webpack_public_path__ + "static/set-probability-97b5d35192f691526390c933a2bc5fcc.png";